import ActionHelper from '@wetransfer/transfer/modules/redux-actions';
import { UploadNotificationSound } from '@wetransfer/transfer/modules/upload-notifications/upload-notifications';

export enum UploadNotificationActions {
  SET_UPLOAD_NOTIFICATION_ACTIVE = 'SET_UPLOAD_NOTIFICATION_ACTIVE',
  SET_UPLOAD_NOTIFICATION_SOUND = 'SET_UPLOAD_NOTIFICATION_SOUND',
}

export default ActionHelper.generate({
  setActive: (active: boolean) => ({
    type: UploadNotificationActions.SET_UPLOAD_NOTIFICATION_ACTIVE,
    payload: active,
  }),
  setSound: (sound: UploadNotificationSound) => ({
    type: UploadNotificationActions.SET_UPLOAD_NOTIFICATION_SOUND,
    payload: sound,
  }),
});
